import { BaseError } from './base';

export class UnavailableInServerSideError extends BaseError {
  constructor(unavailableFeature: string) {
    super({
      cause: null,
      code: 'unavailable_in_server_side_error',
      docsUrl: null,
      name: 'UnavailableInServerSideError',
      shortMessage: `This function is not available in server-side rendering: ${unavailableFeature}`,
    });
  }
}
